import { homepagePublicContent } from "@/lib/seo/publicSiteContent";
import Link from "next/link";

export function HomepageAgentSummary() {
  return (
    <section
      className="relative z-30 border-y border-[#d9dedb] bg-[#f7f5ef] px-5 py-14 text-[#17211f] sm:px-6 sm:py-16"
      data-homepage-public-summary
    >
      <div className="mx-auto max-w-6xl">
        <header className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b64319]">
            {homepagePublicContent.eyebrow}
          </p>
          <h1 className="mt-3 font-serif text-3xl font-bold tracking-tight sm:text-4xl">
            {homepagePublicContent.title}
          </h1>
          <div className="mt-5 space-y-4 text-base leading-7 text-[#52605d]">
            {homepagePublicContent.introduction.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </header>

        <div className="mt-10 grid gap-x-10 gap-y-9 lg:grid-cols-3">
          {homepagePublicContent.sections.map((section) => (
            <section key={section.heading}>
              <h2 className="text-lg font-bold">{section.heading}</h2>
              {section.paragraphs ? (
                <div className="mt-4 space-y-4 text-sm leading-6 text-[#64706d]">
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              ) : null}
              {section.items ? (
                <ul className="mt-4 space-y-5">
                  {section.items.map((item) => (
                    <li key={item.title} className="border-l-2 border-[#d67a52] pl-4">
                      <h3 className="text-sm font-bold">{item.title}</h3>
                      <p className="mt-1 text-sm leading-6 text-[#64706d]">{item.description}</p>
                    </li>
                  ))}
                </ul>
              ) : null}
            </section>
          ))}
        </div>

        <nav
          aria-label="ChickyTutor public information"
          className="mt-12 flex flex-wrap gap-x-5 gap-y-3 border-t border-[#d9dedb] pt-6 text-sm font-semibold"
        >
          {homepagePublicContent.links.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="text-[#0f7487] transition hover:text-[#b64319] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#0f7487]"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </section>
  );
}
